import './styles.scss';

import React, { memo } from 'react';

import {
  Progress,
  ProgressProps,
} from 'antd';

export interface CustomProgressProps extends ProgressProps {
  width?: number;
  strokeWidth?: number;
  showFill?: boolean;
}

const CustomProgress: React.FC<CustomProgressProps> = ({
  type = 'circle',
  width = 20,
  percent = 0,
  size,
  status,
  strokeColor = 'var(--success)',
  strokeWidth = 6,
  trailColor = 'var(--border)',
  showFill = false,
  ...props
}) => {
  return (
    <Progress
      type={type}
      percent={percent}
      className={
        showFill && percent >= 100 ? 'percentcomplete' : 'progress-goiningon'
      }
      width={width}
      size={size}
      status={status || (percent >= 100 ? 'success' : 'active')}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
      trailColor={trailColor}
      {...props}
    />
  );
};

export default memo(CustomProgress);
